import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const ClientExperienceSettingsSection: React.FC = () => (
  <SettingsHubSection section="client-experience" />
);

export default ClientExperienceSettingsSection;
